var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./modules/services/validator", "./modules/components/togglePassword", "./modules/utils/validator", "./modules/services/toastNotification", "./modules/utils", "axios", "./modules/constants", "./modules/components/uploadModal"], function (require, exports, validator_1, togglePassword_1, validator_2, toastNotification_1, utils_1, axios_1, constants_1, uploadModal_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    validator_1 = __importStar(validator_1);
    validator_2 = __importDefault(validator_2);
    utils_1 = __importDefault(utils_1);
    axios_1 = __importDefault(axios_1);
    var notificationMs = 4000;
    var BASE_URL = 'autosservico';
    var HOLDER_URL = 'titular';
    var LOGIN_URL = 'auth';
    var txtFirstName = document.querySelector('#txtFirstName');
    var txtCpf = document.querySelector('#txtCpf');
    var txtRg = document.querySelector('#txtRg');
    var txtIssuingAgency = document.querySelector('#txtIssuingAgency');
    var cbbState = document.querySelector('#cbbState');
    var txtForeignDocument = document.querySelector('#txtForeignDocument');
    var txtCountry = document.querySelector('#txtCountry');
    var txtPassword = document.querySelector('#txtPassword');
    var txtPasswordConfirmation = document.querySelector('#txtPasswordConfirmation');
    var createUserForm = document.querySelector('#createUserForm');
    var btnConfirmar = document.querySelector('#btnConfirmar');
    var btnEnviarDocs = document.querySelector('#btnEnviarDocs');
    var disabledClassesForConfirmButton = ['bg-linx-purple-1100', 'text-white', 'opacity-50', 'cursor-not-allowed'];
    var enabledClassesForConfirmButton = ['bg-linx-purple-1100', 'text-white', 'cursor-pointer', 'border-linx-purple-1100', 'hover:border-linx-purple-1200', 'hover:bg-linx-purple-1200'];
    var docsValidationEnabled = !!btnEnviarDocs;
    var uploadModal;
    var onLoad = function () {
        txtFirstName.focus();
        togglePassword_1.togglePasswordVisibility();
        var formValidator = validation.getValidator(createUserForm).onSuccess(cadastrar);
        txtRg.addEventListener('blur', function () {
            if (txtRg.value.trim() === '')
                clearValidationErros(txtIssuingAgency, cbbState);
        });
        txtForeignDocument.addEventListener('blur', function () {
            if (txtForeignDocument.value.trim() === '')
                clearValidationErros(txtCountry);
        });
        txtPasswordConfirmation.addEventListener('blur', function () {
            if (txtPasswordConfirmation.value.trim() !== '')
                formValidator.revalidateField('#txtPassword');
        });
        btnEnviarDocs === null || btnEnviarDocs === void 0 ? void 0 : btnEnviarDocs.addEventListener('click', function () {
            if (uploadModal == null) {
                uploadModal = new uploadModal_1.UploadModal();
            }
            else {
                uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.Start();
            }
        });
    };
    var cadastrar = function (ev) {
        var _a, _b;
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        disableBtnConfirmar();
        var cpf = txtCpf.value.trim();
        var rg = txtRg.value.trim();
        var docEstrangeiro = txtForeignDocument.value.trim();
        if (cpf === "" && rg === "" && docEstrangeiro === "") {
            toastNotification_1.ToastNotification.Error('Informe ao menos um documento para concluir o cadastro (CPF, RG ou Doc. Estrangeiro).', notificationMs);
            enableBtnConfirmar();
            return;
        }
        var formData = new FormData(createUserForm);
        if (docsValidationEnabled) {
            var docs = (_a = uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.fileList) !== null && _a !== void 0 ? _a : new Map();
            if (docs.size <= 0) {
                toastNotification_1.ToastNotification.Error('É necessário enviar ao menos uma foto ou imagem do documento informado no cadastro.');
                enableBtnConfirmar();
                return;
            }
            if (!((_b = uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.GetCbxUpload()) === null || _b === void 0 ? void 0 : _b.checked)) {
                toastNotification_1.ToastNotification.Error('É necessário confirmar que o(s) arquivos(s) enviado(s) são referentes ao documento informado.');
                enableBtnConfirmar();
                return;
            }
            uploadModal === null || uploadModal === void 0 ? void 0 : uploadModal.fileList.forEach(function (file, _) {
                formData.append('Documentos', file);
            });
        }
        var returnUrl = utils_1.default.findGetParameter('returnurl');
        if (returnUrl === null || returnUrl === undefined || returnUrl === '')
            return;
        axios_1.default.post(BASE_URL + "/" + HOLDER_URL + "/cadastrar?returnUrl=" + returnUrl, formData)
            .then(function (response) { return handleRequestSuccess(response.data.message, returnUrl); })
            .catch(function (error) {
            var _a, _b, _c;
            enableBtnConfirmar();
            toastNotification_1.ToastNotification.Error((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : constants_1.DefaultError);
        });
    };
    var handleRequestSuccess = function (message, returnUrl) {
        var timeout = 20000;
        var redirectFunc = function () { return window.location.href = BASE_URL + "/" + LOGIN_URL + "/login?returnUrl=" + returnUrl; };
        toastNotification_1.ToastNotification.Success(message, timeout, redirectFunc);
        setTimeout(redirectFunc, timeout);
    };
    var validation = {
        getValidator: function (form) {
            return validator_1.default(form)
                .addField('#txtFirstName', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe o nome.'
                }
            ])
                .addField('#txtLastName', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe o sobrenome.'
                }
            ])
                .addField('#txtCpf', [
                {
                    validator: function (value) { return value ? validator_2.default.cpfValido(String(value)) : true; },
                    errorMessage: 'Informe um CPF válido.'
                }
            ])
                .addField('#txtIssuingAgency', [
                {
                    validator: function (value) { return txtRg.value.trim() ? String(value).trim() !== "" : true; },
                    errorMessage: 'O órgão emissor deve ser informado ao informar o RG.'
                }
            ])
                .addField('#cbbState', [
                {
                    validator: function (value) { return txtRg.value.trim() ? String(value).trim() !== "" : true; },
                    errorMessage: 'O estado deve ser informado ao informar o RG.'
                }
            ])
                .addField('#txtCountry', [
                {
                    validator: function (value) { return txtForeignDocument.value.trim() ? String(value).trim() !== "" : true; },
                    errorMessage: 'O país deve ser informado ao informar o doc. estrangeiro.'
                }
            ])
                .addField('#txtEmail', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe o e-mail.'
                },
                {
                    rule: validator_1.Rules.Email,
                    errorMessage: 'Informe um e-mail válido.'
                }
            ])
                .addField('#txtPassword', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe a senha.'
                },
                {
                    validator: validator_1.strongPasswordValidator,
                    errorMessage: "A senha deve conter no m\u00EDnimo 12 caracteres, pelo menos uma letra mai\u00FAscula, \n                               uma letra min\u00FAscula, um n\u00FAmero e um caractere especial"
                },
                {
                    validator: function (value) { return value === txtPasswordConfirmation.value; },
                    errorMessage: 'As senhas não conferem.'
                }
            ]);
        }
    };
    var clearValidationErros = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        elements.forEach(function (el) {
            var _a, _b;
            (_b = (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.just-validate-error-label')) === null || _b === void 0 ? void 0 : _b.remove();
            el.classList.remove('is-invalid');
        });
    };
    var disableBtnConfirmar = function () {
        var _a, _b;
        btnConfirmar.setAttribute('disabled', 'disabled');
        (_a = btnConfirmar.classList).remove.apply(_a, enabledClassesForConfirmButton);
        (_b = btnConfirmar.classList).add.apply(_b, disabledClassesForConfirmButton);
    };
    var enableBtnConfirmar = function () {
        var _a, _b;
        btnConfirmar.removeAttribute('disabled');
        (_a = btnConfirmar.classList).remove.apply(_a, disabledClassesForConfirmButton);
        (_b = btnConfirmar.classList).add.apply(_b, enabledClassesForConfirmButton);
    };
    window.addEventListener('load', onLoad);
});
